import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FledgedChickBaseService } from './fledgedchick-base.service';

@Injectable()
export class FledgedChickService extends FledgedChickBaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }
}
